module.exports = __webpack_public_path__ + "img/jobs_example2.ad3b32f3.jpg";